import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.locale('ru')

export function formatRelativeTime(date: string | Date): string {
  return dayjs(date).fromNow()
}
